/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Heading_Combined_Continuity_SpottingInputs */



/**
* | output |
* | --- |
* | "COMBINED CONTINUITY & SPOTTING LIST" |
*
* @param {Ccsl_Export_Heading_Combined_Continuity_SpottingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_heading_combined_continuity_spotting = /** @type {((inputs?: Ccsl_Export_Heading_Combined_Continuity_SpottingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Heading_Combined_Continuity_SpottingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("CONTINUITE ET LISTE DE REPERAGE COMBINEES")
	if (locale === "de") return /** @type {LocalizedString} */ ("KOMBINIERTE KONTINUITÄTS- UND SPOTTING-LISTE")
	if (locale === "it") return /** @type {LocalizedString} */ ("LISTA COMBINATA DI CONTINUITÀ E DI AVVISTAMENTO")
	if (locale === "ru") return /** @type {LocalizedString} */ ("СВОДНЫЙ СПИСОК ПО СЛЕДУЮЩИМ ОБЗОРАМ И НАБЛЮДАНИЮ ЗА СИТУАЦИЕЙ")
	if (locale === "es") return /** @type {LocalizedString} */ ("LISTA COMBINADA DE CONTINUIDAD Y DETECTADO")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("综合连续性和定位列表")
	if (locale === "ja") return /** @type {LocalizedString} */ ("連続性とスポッティングリストの組み合わせ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संयुक्त निरंतरता और स्पॉटिंग सूची")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("LISTA COMBINADA DE CONTINUIDADE E IDENTIFICAÇÃO")
	return /** @type {LocalizedString} */ ("COMBINED CONTINUITY & SPOTTING LIST")
});